import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";
import {SystemLogsFilter} from "@/model/filters";


export async function getAll(filter: SystemLogsFilter): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  if (filter.q) {
    body.filters.push({
      field: "message", operator: "contains", value: filter.q, logic: "and"
    });
  }

  if (filter.logLevel) {
    body.filters.push({
      field: "logLevel", operator: "eq", value: filter.logLevel, logic: "and"
    });
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/Logs/GetAll", body, { headers })).data;
}

export async function del(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Logs/Delete", null, { headers, params })).data;
}

export async function getPolicy() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Logs/Policy", { headers })).data;
}

export async function setPolicy(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Logs/Policy", data, { headers })).data;
}
